import React, { useEffect, useState } from "react";
import { RESTExecutor, withDomains } from "../lib/domain";
import { Menu, message } from "antd";

import {
  PlusOutlined,
  SettingOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { getImageUrl } from "../util/ui_util";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { HomeTabs } from "../components/home-tabs";
import { TopHeader } from "../components/top-header";
import OrganizationList from "../components/organization-list";
import RequestList from "../components/request-list";
import InvitationList from "../components/invitation-list";
import { WelcomeModal } from "../components/welcomeModal";

let userName = "";
let imgSource = "";

const MainApplication = ({ domains, authenticator, ...props }) => {
  const [userInfo, setUserInfo] = useState({});
  let get_companies = RESTExecutor.list()
    .config({
      label: "namespace_register",
      params: { status: "Pending" },
    })
    .callbacks(
      (success) => {},
      (error) => {
        console.log(error);
        error.error_message && message.error(error.error_message);
      }
    )
    .connect(domains.register);

  let list_namespace = RESTExecutor.list()
    .config({
      label: "list_namespace",
    })
    .connect(domains.user);

  let get_user = RESTExecutor.list()
    .config({
      label: "me",
    })
    .callbacks((success) => {
      // setResult(success.result);
      setUserInfo(success.result);
      imgSource = getImageUrl(success.result)
        ? getImageUrl(success.result)
        : `https://ui-avatars.com/api/?name=${
            success.result.name.split(" ")[0]
          }+${
            success.result.name.split(" ")[1]
          }&background=var(--primary-tint)&color=fff&size=36&rounded=true`;
      userName =
        success.result.name == "" ? success.result.email : success.result.name;
    })
    .connect(domains.user);

  let namespace_invitations = RESTExecutor.list()
    .config({
      label: "namespace_invitations",
      params: { status: "Pending" },
    })
    .callbacks((success) => {})
    .connect(domains.user);

  useEffect(() => {
    namespace_invitations.execute(true);
    list_namespace.execute(true);
    get_user.execute(true);
    get_companies.execute(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let invitations_resp = namespace_invitations.response();
  let companies_resp = get_companies.response();

  const inviteCount = invitations_resp?.result?.length;
  const companiesCount = companies_resp?.result?.length;

  let menu = (
    <Menu className={"dropdown-menu"}>
      <Menu.Item
        key="1"
        icon={<img className="user-avatar-img" src={imgSource} />}
      >
        <span className="menu-item-text">{userName}</span>
      </Menu.Item>
      <Menu.Divider />

      <Menu.Item
        key="2"
        icon={<PlusOutlined />}
        onClick={() => {
          props.history.push("/new-company");
        }}
      >
        Add New Company
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="3"
        icon={<SettingOutlined />}
        onClick={() => {
          props.history.push("/account-settings");
        }}
      >
        Account Settings
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="4"
        icon={<LogoutOutlined />}
        onClick={() => {
          authenticator.logout();
          props.history.push("/");
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const selectedTab = query.get("tab");

  return (
    <div className={"application-container"}>
      {/* Site Header */}
      <div style={{ boxShadow: "0px 6px 30px 0px #07073F1A" }}>
        <TopHeader userInfo={userInfo} menu={menu} imgSource={imgSource} />

        <div style={{ height: "45px", margin: "0 auto", width: "80%" }}>
          <HomeTabs
            invitationCount={inviteCount}
            requestCount={companiesCount}
            userInfo={userInfo}
          />
        </div>
      </div>

      <div
        className="main-container"
        style={{
          height: "calc(100vh - 125px)",
          background: "#EEF2F7",
          overflowY: "auto",
          display: "flex", 
          flexDirection: "column", 
          justifyContent: "flex-start",
        }}
      >
        <div
          // className="dashboard-container"
          style={{
            width: "80%",

            display: "flex",
            flexDirection: "column",
            paddingTop: "24px",
            gap: "24px",
            paddingBottom: "48px",
          }}
        >
          {/* <GridView /> */}

          {(selectedTab === "undefined" ||
            !selectedTab ||
            selectedTab === "org") && (
            <OrganizationList {...props} userInfo={userInfo} />
          )}
          {selectedTab === "request" && <RequestList {...props} />}
          {selectedTab === "invitation" && <InvitationList {...props} />}
        </div>
      </div>

      {/* </div> */}
    </div>
  );
};

export default withDomains(
  MainApplication,
  "user",
  "auth",
  "upgradeCredentials",
  "register"
);
